import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import FromServer from './FromServer';
import BugeteListProiect from '../../commons/BugeteListProiect'
import CosturiListProiect from '../../commons/CosturiListProiect'
import AddBugeteProiect from '../../commons/dialogs/AddBugeteProiect'
import AddCosturiProiect from '../../commons/dialogs/AddCosturiProiect'
import { Fab, Divider, Avatar, Grid, Button } from '@material-ui/core';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import CosturiUpdate from '../../commons/dialogs/CosturiUpdate';
import Ws from '../../providers/Ws';

import { ReactComponent as Step1Green } from '../../Pics/iconsManagement/step1_green.svg';
import { ReactComponent as Step2Green } from '../../Pics/iconsManagement/step2_green.svg';
import { ReactComponent as Step3Green } from '../../Pics/iconsManagement/step3_green.svg';
import { ReactComponent as Step4 } from '../../Pics/iconsManagement/step4.svg';

export default class BugeteProiecte extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            bugeteTipuri: [],
            costuriTipuri: [],
            bugeteProiect: [],
            costuriProiect: [],
            isOpenInsert: false,
            isOpenInsertCost: false,
            isOpenCostUpdate: false,
            objCost: {},
            users: [],
            objUser: { poza: '', nume: '' },
            insertedCostId: 0,
            listNrTaskuri: [],
            objProiect: {},
            showAngajatiAlocati: false,
            showCosturi: false,
            numeProdus: '',
            cantitate: 1,
            pret: 0,
            tva: '19',
            totalValoare: 0,
            valoriTva: new Utils().valoriTva,
            etape: [],
            etapaSelectata: '0',
            activeStep: 3,
            steps: [
                { id: 0, done: true, icon: <Step1Green style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoProiect' },
                { id: 1, done: false, icon: <Step2Green style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToUtilizatori' },
                { id: 2, done: false, icon: <Step3Green style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoEtape' },
                { id: 3, done: false, icon: <Step4 style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoBuget' }
            ],

        }
    }

    bugetInfo = {}

    componentDidMount() {
        this.getData()
    }

    getIcons = () => {



        return this.state.steps.map((s, idx) => {

            return (
                <div key={idx} style={{ display: 'inline-block' }} onClick={this.props[s.goTo]}>
                    {s.icon}

                </div>
            )
        })
    }

    getData = async () => {
        let fs = new FromServer();

        let u = new Utils()

        // console.log('this.props.projectid :', this.props.idproiect);
        let _tipuriBC = fs.getBugeteCosturiTipuri(this.props.idproiect);
        let _proiectB = fs.getBugetProiect(this.props.idproiect)
        let _proiectBC = fs.getBugeteEtape(this.props.idproiect)
        let _users = fs.getUsers(this.props.idproiect)
        let _nrTaskuri = fs.nrTaskuriByUser(this.props.idproiect)
        let _proiect = fs.getInfoProiect(this.props.idproiect)

        let [tipuriBC, proiectB, proiectBC, users, nrTaskuri, proiect] = await Promise.all([_tipuriBC, _proiectB, _proiectBC, _users, _nrTaskuri, _proiect])

        // console.log('tipuriBC :', tipuriBC);
        // console.log('proiectBC :', proiectBC);
        // console.log('nrTaskuri :', nrTaskuri);


        let costuri2 = await new Ws().customSelect('select * from costuri_etape ', {
            p1: 1
        })

        console.log('proiectB :>> ', proiectB);

        console.log('proiectBC :>> ', proiectBC);

        console.log('costuri2 :>> ', costuri2);


        let bugetP = proiectB.Content

        let costuri = proiectBC.costuri

        console.log('consturi :>> ', costuri);

        let costuriL = costuri.length


        for (let i = 0; i < costuriL; i++) {
            costuri[i].adaugat_la = u.ParseDataFromSql(costuri[i].adaugat_la)
            costuri[i].data_costului = u.ParseDataFromSql(costuri[i].data_costului)
            costuri[i].edit = false
            costuri[i].id_proiect = 0

            let idx = proiectBC.etape.findIndex(e => e.id === costuri[i].id_etapa)


            if (idx !== -1) {
                costuri[i].nume_etapa = proiectBC.etape[idx].denumire
            }
        }


        for (let i = 0; i < costuriL; i++) {

        }
        // console.log('costuri :', costuri);

        // if (this.state.insertedCostId !== 0) {
        //     let cost = costuri.filter(c => c.id === this.state.insertedCostId)

        //     this.costClick(cost[0])
        // }


        console.log('costuri :>> ', costuri);

        costuri = costuri.sort((a, b) => {
            if (a.id_etapa < b.id_etapa) {
                return -1
            } else {
                return 1
            }
        })

        this.setState({
            bugeteTipuri: tipuriBC.bugeteT,
            etape: proiectBC.etape,
            costuriTipuri: tipuriBC.costuriT,
            bugeteProiect: proiectBC.bugete,
            costuriProiect: costuri,
            users: users,
            objProiect: proiect[0],
            listNrTaskuri: nrTaskuri
        })
    }


    bugetClick = (b) => {
        // console.log('buget :', b);
    }

    valoareChange = (e, ev) => {

        let cloneBugete = [...this.state.bugeteProiect]

        let idx = cloneBugete.findIndex(c => c.id === e.id)

        cloneBugete[idx].valoare = ev.target.value

        this.setState({ bugeteProiect: cloneBugete })

    }

    insertBuget = async (b) => {
        // console.log('buget :', b);

        let ls = new LocalStorage();
        let u = new Utils();
        let fs = new FromServer();

        let obj = {
            id_tip: b.id,
            id_proiect: this.props.idproiect,
            valoare: 0,
            insert_nume_user: ls.GetUserData().Nume,
            insert_id_user: ls.GetUserData().InfoUser.IdUser,
            insert_cand: u.updateSqlNow(),

        }

        // console.log('obj :', obj);


        let insertBuget = await fs.insertBugetProiect(obj);

        if (insertBuget) {
            this.setState({ isOpenInsert: false }, () => {
                this.getData()
            })
        }
    }



    updateValoare = (v) => {
        // console.log('v :', v);

        let fs = new FromServer();
        let u = new Utils();
        let ls = new LocalStorage();

        let obj = {
            valoare: v.valoare,
            edit_nume_user: ls.GetUserData().Nume,
            edit_id_user: ls.GetUserData().InfoUser.IdUser,
            edit_cand: u.updateSqlNow()
        }


        let updateBugete = fs.updateBugetProiect(obj, { id: v.id })


    }

    insertCost = async () => {


        let ls = new LocalStorage();
        let u = new Utils();
        let fs = new FromServer();
        let ws = new Ws()


        if (this.state.etapaSelectata !== '-1') {
            let obj = {
                id_etapa: Number(this.state.etapaSelectata),
                // id_proiect:this.props.idproiect,
                // valoare: (Number(this.state.pret) + (Number(this.state.pret) * Number(this.state.tva) / 100)) * Number(this.state.cantitate),
                valoare: (Number(this.state.pret)) * Number(this.state.cantitate),
                data_bugetului: u.updateSqlNow(),
                // adaugat_la: u.updateSqlNow(),
                tva: Number(this.state.tva) || 0,
                cantitate: this.state.cantitate || 0,
                nume: this.state.numeProdus || '',

            }

            console.log('obj :', obj);


            let insertCost = await ws.insert('bugete_etape', obj)

            console.log('insertCost :', insertCost);

            if (insertCost.Succes) {
                this.setState({
                    isOpenInsertCost: false,
                    isOpenCostUpdate: false,
                    insertedCostId: insertCost.Content[0].id,
                    numeProdus: '',
                    cantitate: 1,
                    pret: 0,
                    tva: '19',
                    etapaSelectata: '0'
                }, () => {
                    this.getData()

                })
            }

        } else {

            let obj = {
                id_proiect: Number(this.props.idproiect),
                // id_proiect:this.props.idproiect,
                id_tip: 1,
                // valoare: (Number(this.state.pret) + (Number(this.state.pret) * Number(this.state.tva) / 100)) * Number(this.state.cantitate),
                valoare: (Number(this.state.pret)) * Number(this.state.cantitate),
                // data_bugetului: u.updateSqlNow(),
                // // adaugat_la: u.updateSqlNow(),
                // tva: Number(this.state.tva) || 0,
                // cantitate: this.state.cantitate || 0,
                // nume: this.state.numeProdus || '',




            }

            let insertCost = await ws.insert('proiecte_bugete', obj)

        }





    }

    editCost = async (c) => {



        let u = new Utils();

        let ws = new Ws()

        console.log('c :>> ', c);


        let obj = {
            id_etapa: c.id_etapa,
            // valoare: (Number(this.state.pret) + (Number(this.state.pret) * Number(this.state.tva) / 100)) * Number(this.state.cantitate),
            valoare: Number(c.valoare),
            data_bugetului: u.updateSqlNow(),
            // adaugat_la: u.updateSqlNow(),
            tva: c.tva || 0,
            // cantitate: this.state.cantitate || 0,
            nume: c.nume || '',

        }

        console.log('obj :', obj);


        let insertCost = await ws.update('bugete_etape', obj, { id: c.id })

        console.log('insertCost :', insertCost);

        if (insertCost.Succes) {
            this.setState({
                isOpenInsertCost: false,
                isOpenCostUpdate: false,

            }, () => {
                this.getData()

            })
        }





    }

    deleteCost = async (c) => {

        console.log('c :>> ', c);

        let ws = new Ws()

        let del = await ws.update('bugete_etape', { sters: 1 }, { id: c.id })

        if (del.Succes) {
            this.getData()
        }

    }

    valoareCostChange = (e, ev) => {

        let cloneCosturi = [...this.state.costuriProiect]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].valoare = ev.target.value

        this.setState({ costuriProiect: cloneCosturi })

    }

    dataCostChange = (e, ev) => {
        let cloneCosturi = [...this.state.costuriProiect]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].data_costului = ev.target.value

        this.setState({ costuriProiect: cloneCosturi })
    }

    updateValoareCost = async (v) => {
        // console.log('v :', v);

        let ws = new Ws()

        let obj = {
            valoare: v.valoare,

        }


        let updateBugete = await ws.update('bugete_etape', obj, { id: v.id })


    }



    updateDataCost = async (d) => {


        let ws = new Ws()

        let obj = {
            data_costului: d.data_costului,

        }


        let updateBugete = await ws.update('bugete_etape', obj, { id: d.id })

    }

    updateNume = async (e) => {
        // console.log('v :', e);

        let ws = new Ws()

        let obj = {
            nume: e.nume
        }


        //  console.log('obj :', obj);

        let updateN = await ws.update('bugete_etape', obj, { id: e.id })


    }



    costClick = (c) => {
        // console.log('cost :', c);

        let users = [...this.state.users]

        let user = users.filter(u => u.id === c.adaugat_de)



        this.setState({
            objCost: c,
            isOpenCostUpdate: true,
            objUser: user[0]
        })
    }


    changeCost = nume => ev => {
        let cost = { ...this.state.objCost }

        cost[nume] = ev.target.value

        this.setState({
            objCost: cost
        })
    }

    // updateCost = async (c) => {
    //     console.log('c :', c);

    //     let fs = new FromServer();

    //     let objToUpdate = {
    //         id_proiect: c.id_proiect || '',
    //         id_tip: c.id_tip || '',
    //         explicatie: c.explicatie || '',
    //         note: c.note || "",
    //         data_costului: c.data_costului || "",
    //         adaugat_la: c.adaugat_la || '',
    //         adaugat_de: c.adaugat_de || '',
    //         valoare: c.valoare || 0
    //     }



    //     console.log('objToUpdate :', objToUpdate);

    //     let update = await fs.updateCostProiect(objToUpdate, { id: c.id })

    //     console.log('update cost :');

    //     console.log('update :', update);

    //     if (update) {
    //         console.log('isOpenCostUpdate :', this.state.isOpenCostUpdate);
    //         this.setState({
    //             isOpenCostUpdate: false,
    //             insertedCostId: 0
    //         }, () => {



    //             this.getData()
    //         })
    //     }

    // }


    getLitereAvatar = (tx) => {

        if (tx !== null) {

            return tx.substring(0, 1).toUpperCase()
        }
    }

    changeCellValue = (ev) => {
        // console.log('ev :', ev);
        this.setState({
            [ev.target.name]: ev.target.value,
            totalValoare: (this.state.pret + (this.state.pret * this.state.tva / 100)) * this.state.cantitate
        })
    }

    numeConstChange = (e, ev) => {
        let cloneCosturi = [...this.state.costuriProiect]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].nume = ev.target.value

        this.setState({ costuriProiect: cloneCosturi })
    }

    

    changeCostSelectat = (ev, c) => {

        let val = ev.target.value
        let n = ev.target.name

        let costuriClone = [...this.state.costuriProiect]

        let idx = costuriClone.findIndex(cp => cp.id === c.id)

        if (idx !== -1) {

            costuriClone[idx][n] = val

            this.setState({ costuriProiect: costuriClone })

        }
    }


    openEditCost = (c) => {
        let costuri = [...this.state.costuriProiect]

        let idx = costuri.findIndex(cp => cp.id === c.id)

        if (idx !== -1) {
            costuri[idx]["edit"] = true

            this.setState({ costuriProiect: costuri })
        }
    }

    render() {
        return (
            <div>
                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white' }}>


                    <div style={{ position: 'absolute', top: -20, left: 0, right: 0, margin: "auto" }}>
                        {this.getIcons()}
                    </div>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 20, fontWeight: 500, color: 'black', marginBottom: 0 }}>
                            {this.dictionary.proiecte.definesteCheltuielile}

                        </h4>

                    </Grid>
                    <Grid style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 20, marginTop: 40 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Grid style={{ fontSize: 14 }} container>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <span style={{ fontWeight: 600 }}>{this.dictionary.proiecte.etapaProiectului} </span>

                            </Grid>

                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>

                                <span style={{ fontWeight: 600 }}>{this.dictionary.proiecte.denumireCheltuiala} </span>

                            </Grid>

                            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                <span style={{ fontWeight: 600 }}>TVA</span>

                            </Grid>

                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                <span style={{ fontWeight: 600 }}>{this.dictionary.proiecte.valoare}</span>


                            </Grid>




                        </Grid>
                    </Grid>


                    {this.state.costuriProiect.map((c, idx) => {

                        if (c.edit) {
                            return (
                                <Grid key={idx} style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >






                                    <Grid container>
                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                            <select
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='id_etapa'
                                                value={c.id_etapa}
                                                onChange={(ev) => { this.changeCostSelectat(ev, c) }}
                                                placeholder={this.dictionary.proiecte.selectEtapaProiect}
                                            >
                                                <option value={'0'}>{this.dictionary.proiecte.selectEtapaProiect}</option>
                                                {/* <option value={'-1'}>Tot Proiectul</option> */}

                                                {this.state.etape.map((l, idx) => {
                                                    return (
                                                        <option key={idx} value={l.id}>{l.denumire}</option>
                                                    )
                                                })}

                                            </select>

                                        </Grid>

                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>

                                            <input
                                                style={{ width: '90%' }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='nume'
                                                value={c.nume || ""}
                                                onChange={(ev) => { this.changeCostSelectat(ev, c) }}
                                                placeholder={this.dictionary.proiecte.spendingName}
                                            />


                                        </Grid>

                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>

                                            <select
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='tva'
                                                value={c.tva}
                                                onChange={(ev) => { this.changeCostSelectat(ev, c) }}
                                                placeholder={this.dictionary.proiecte.tva}
                                            >
                                                <option value={'0'}>-</option>

                                                {this.state.valoriTva.map((l, idx) => {
                                                    return (
                                                        <option key={idx} value={l}>{l}</option>
                                                    )
                                                })}

                                            </select>

                                            {/* <input
                                                style={{ width: '90%' }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='tva'
                                                value={c.tva|| ""}
                                                onChange={(ev)=>{this.changeCostSelectat(ev,c)}}
                                                placeholder='TVA'
                                            /> */}


                                        </Grid>

                                        <Grid style={{ textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                            <input
                                                style={{ width: '90%' }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='valoare'
                                                value={c.valoare || ""}
                                                onChange={(ev) => { this.changeCostSelectat(ev, c) }}
                                                placeholder={this.dictionary.proiecte.value}
                                            />


                                        </Grid>

                                        <Grid item style={{ textAlign: 'center' }} item xs={1} sm={1} md={1} lg={1} xl={1} >

                                            <i
                                                onClick={() => { this.editCost(c) }}
                                                style={{
                                                    backgroundColor: 'rgb(24, 165, 58)',
                                                    cursor: 'pointer',
                                                    color: 'white',
                                                    borderRadius: 20,
                                                    padding: 5,
                                                    verticalAlign: 'middle',
                                                }} className='material-icons'>check_circle_outline</i>


                                        </Grid>


                                    </Grid>





                                </Grid>
                            )
                        } else {
                            return (
                                <Grid key={idx} style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >






                                    <Grid style={{ fontSize: 14 }} container>
                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                            <span>{c.nume_etapa}</span>

                                        </Grid>

                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>

                                            <span>{c.nume}</span>


                                        </Grid>

                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>

                                            <span>{c.tva}</span>


                                        </Grid>

                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                            <span>{c.valoare}</span>

                                        </Grid>

                                        <Grid item style={{ textAlign: 'center' }} item xs={1} sm={1} md={1} lg={1} xl={1} >

                                            <i onClick={() => { this.openEditCost(c) }} style={{ marginRight: 5, cursor: 'pointer' }} className='material-icons'>edit</i>
                                            <i style={{ cursor: 'pointer' }} onClick={() => { this.deleteCost(c) }} className='material-icons'>delete</i>


                                        </Grid>


                                    </Grid>





                                </Grid>
                            )
                        }
                    })}

                    <Grid style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 20, }} item xs={12} sm={12} md={12} lg={12} xl={12} >






                        <Grid container>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <select
                                    style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                    className='add-project-input'
                                    type="text"
                                    margin="normal"
                                    name='id_user_responsabil'
                                    value={this.state.etapaSelectata}
                                    onChange={(ev) => { this.setState({ etapaSelectata: ev.target.value }) }}
                                    placeholder={this.dictionary.proiecte.selectEtapaProiect}
                                >
                                    <option value={'0'}>{this.dictionary.proiecte.selectEtapaProiect}</option>
                                    {/* <option value={'-1'}>Tot proiectul</option> */}
                                    {this.state.etape.map((l, idx) => {
                                        return (
                                            <option key={idx} value={l.id}>{l.denumire}</option>
                                        )
                                    })}

                                </select>

                            </Grid>

                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>

                                <input
                                    style={{ width: '90%' }}
                                    className='add-project-input'
                                    type="text"
                                    margin="normal"
                                    name='denumire'
                                    value={this.state.numeProdus || ""}
                                    onChange={(ev) => { this.setState({ numeProdus: ev.target.value }) }}
                                    placeholder={this.dictionary.proiecte.spendingName}
                                />


                            </Grid>

                            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>

                                <select
                                    style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                    className='add-project-input'
                                    type="text"
                                    margin="normal"
                                    name='tva'
                                    value={this.state.tva}
                                    onChange={(ev) => { this.setState({ tva: ev.target.value }) }}
                                    placeholder={this.dictionary.proiecte.tva}
                                >
                                    <option value={'0'}>-</option>

                                    {this.state.valoriTva.map((l, idx) => {
                                        return (
                                            <option key={idx} value={l}>{l}</option>
                                        )
                                    })}

                                </select>


                            </Grid>

                            <Grid style={{ textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                <input
                                    style={{ width: '90%' }}
                                    className='add-project-input'
                                    type="text"
                                    margin="normal"
                                    name='denumire'
                                    value={this.state.pret || ""}
                                    onChange={(ev) => { this.setState({ pret: ev.target.value }) }}
                                    placeholder={this.dictionary.proiecte.value}
                                />


                            </Grid>

                            <Grid item style={{ textAlign: 'center' }} item xs={1} sm={1} md={1} lg={1} xl={1} >

                                <i
                                    onClick={this.insertCost}
                                    style={{
                                        backgroundColor: 'rgb(24, 165, 58)',
                                        cursor: 'pointer',
                                        color: 'white',
                                        borderRadius: 20,
                                        padding: 5,
                                        verticalAlign: 'middle',
                                    }} className='material-icons'>check_circle_outline</i>


                            </Grid>


                        </Grid>





                    </Grid>



                </Grid>

                <Grid container style={{ marginTop: 40, textAlign: 'left' }}>
                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button
                            style={{ backgroundColor: '#07B14B', fontSize:14, fontWeight:400, boxShadow:'none' }}
                            variant="contained"
                            className='next-step-projects'
                            color="primary" onClick={this.props.goToProiect}>
                            {this.dictionary.proiecte.spreTaskuri}
                        </Button>
                    </Grid>

                    <Grid style={{ textAlign: 'right' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button
                            style={{ backgroundColor: 'gray', color: 'white', fontSize:14, fontWeight:400, boxShadow:'none'  }}
                            variant="contained"
                            className='next-step-projects'
                            color="primary" onClick={this.props.goToInfoEtape}>
                            {this.dictionary.proiecte.stepBack}
                        </Button>
                    </Grid>
                </Grid>

                {/* <div style={{ border: '1px solid #d4d4d4', padding: 5 }}>
                    <h1 className='pm-title'>{this.state.objProiect.titlu}</h1>
                    <div className='container'>
                        <h3 className='pm-title'>{this.dictionary.bugete.costs}</h3>
                        <Divider className='pm-divider' />
                        <div style={{ textAlign: "center", marginBottom: 20, padding: 15 }}>
                            <Button onClick={() => { this.setState({ isOpenInsertCost: true }) }} className="pm-adauga-button">
                                <i className='material-icons pm-round-button-text'>add</i>
                                Adauga Cost
                     </Button>
                        </div>
                        {this.state.costuriProiect.length > 0 &&
                            <div style={{ textAlign: "center", marginBottom: 20, padding: 15 }}>
                                <Button onClick={() => { this.setState({ showCosturi: this.state.showCosturi ? false : true }) }} className="pm-adauga-button">

                                    Vezi costuri proiect
                                </Button>
                            </div>

                        }


                        {this.state.costuriProiect.length > 0 && this.state.showCosturi &&

                            <div style={{ widthL: 'fit-content', border: '1px solid #dad8d8', marginBottom: 10 }}>

                                {this.state.etape.map((e, idx) => {
                                    return (
                                        <div key={idx}>
                                            <h3 className='pm-title'>{e.denumire}</h3>

                                            <CosturiListProiect
                                                elemente={this.state.costuriProiect.filter(c => c.id_etapa === e.id)}
                                                dict={this.dictionary}
                                                onlyColumns={{ nume: 'nume', valoare: 'valoare', data_costului: 'data_costului' }}
                                                onElClick={this.costClick}
                                                numeChange={this.numeConstChange}
                                                updateNume={this.updateNume}
                                                valoareChange={this.valoareCostChange}
                                                updateValoare={this.updateValoareCost}
                                                dataChange={this.dataCostChange}
                                                updateData={this.updateDataCost}
                                            />
                                            <Divider className='pm-divider' />
                                        </div>
                                    )
                                })}


                            </div>
                        }

                        <Button onClick={() => { this.setState({ showAngajatiAlocati: this.state.showAngajatiAlocati ? false : true }) }} className="pm-adauga-button">

                            Vezi angajati alocati
                    </Button>
                        {this.state.showAngajatiAlocati &&
                            <Grid style={{ margin: '10px auto', width: '90%', border: '1px solid #dad8d8' }} container>
                                <h2 style={{ width: '100%' }} className='pm-title'>{this.dictionary.bugete.angajatiAlocati}</h2>
                                {
                                    this.state.listNrTaskuri.map((t, idx) => {
                                        return (
                                            <Grid key={idx} item xs={12} sm={12} md={6} lg={4} xl={4}>

                                                <div style={{ backgroundColor: 'white', maxWidth: 280 }} className='pm-top-menu-cards'>
                                                    <div style={{ width: 'fit-content', height: '100%', position: 'relative', cursor: 'pointer', marginLeft: 10 }}>

                                                        {
                                                            t.poza &&
                                                            <div
                                                                className='pm-angajati-picture'
                                                                style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + t.poza}')` }}>

                                                            </div>
                                                        }
                                                        {!t.poza &&
                                                            <Avatar style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(t.nume + ' ')} </Avatar>
                                                        }
                                                        <span className='pm-task-change-user'>{t.nume}</span>

                                                    </div>
                                                    <span className='pm-title'>{this.dictionary.organigrama.cost + ': '} {t.cost_minut !== null ? t.cost_minut : 0} </span>

                                                    <span style={{
                                                        display: 'block',
                                                        margin: '20px auto',
                                                        fontWeight: 600
                                                    }} className='pm-title'>{this.dictionary.bugete.nrTaskuri + ': '}<span style={{ color: '#6aab3d' }}>{t.nr_taskuri}</span> </span>
                                                    <span style={{
                                                        display: 'block',
                                                        margin: '20px auto',
                                                        fontWeight: 600
                                                    }} className='pm-title'>{this.dictionary.bugete.nrTaskuriT + ': '}<span style={{ color: '#6aab3d' }}>{t.nr_taskuri_all}</span> </span>

                                                </div>
                                            </Grid>
                                        )
                                    })

                                }
                            </Grid>
                        }



                    </div>
                </div> */}


                <AddBugeteProiect
                    open={this.state.isOpenInsert}
                    dialogClose={() => { this.setState({ isOpenInsert: false }) }}
                    title={this.dictionary.bugete.addBudget}
                    bugeteTipuri={this.state.bugeteTipuri}
                    dict={this.dictionary}
                    bugetAdd={this.insertBuget}
                />

                <AddCosturiProiect
                    showEtape={true}
                    etape={this.state.etape}
                    etapaSelectata={this.state.etapaSelectata}
                    changeEtapa={(ev) => { this.setState({ etapaSelectata: ev.target.value }) }}
                    open={this.state.isOpenInsertCost}
                    dialogClose={() => { this.setState({ isOpenInsertCost: false }) }}
                    title={this.dictionary.bugete.addCost}
                    numeProdus={this.state.numeProdus}
                    cantitate={this.state.cantitate}
                    pret={this.state.pret}
                    tva={this.state.tva}
                    changeCellValue={(ev) => { this.changeCellValue(ev) }}
                    dict={this.dictionary}
                    costAdd={this.insertCost}
                    total={(Number(this.state.pret) + ((Number(this.state.pret) * Number(this.state.tva)) / 100)) * Number(this.state.cantitate)}
                    totalNet={(Number(this.state.pret) * Number(this.state.cantitate))}
                    totalTva={(Number(this.state.pret) * Number(this.state.tva) / 100) * Number(this.state.cantitate)}
                />

                {/* <CosturiUpdate
                    objUser={this.state.objUser}
                    open={this.state.isOpenCostUpdate}
                    dialogClose={() => { this.setState({ isOpenCostUpdate: false }) }}
                    limba={this.dictionary}
                    cost={this.state.objCost}
                    changeCost={this.changeCost}
                    updateCost={this.updateCost}

                /> */}
            </div>
        );
    }
}